export default "__VITE_ASSET__Bcokc5qy__"